import { render, staticRenderFns } from "./Tab-Documents.vue?vue&type=template&id=294299b1&scoped=true"
import script from "./Tab-Documents.vue?vue&type=script&lang=js"
export * from "./Tab-Documents.vue?vue&type=script&lang=js"
import style0 from "./Tab-Documents.vue?vue&type=style&index=0&id=294299b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294299b1",
  null
  
)

export default component.exports